import { Heading, Text } from '@chakra-ui/react'
import styled from '@emotion/styled'

import theme from 'styles/theme'

export const ArticleContentWrapper = styled.div`
  margin: 8px 0 42px 0;

  p,
  li {
    font-weight: 300;
  }

  a {
    color: blue;
    text-decoration: underline;
  }

  .ql-align-center {
    text-align: center;
  }

  .ql-align-right {
    text-align: right;
  }

  .ql-align-justify {
    text-align: justify;
  }

  img {
    margin: 28px auto 14px auto;

    @media (min-width: ${theme.token('breakpoints.lg')}) {
      margin: 48px auto 24px auto;
    }
  }

  @media (min-width: ${theme.token('breakpoints.lg')}) {
    margin: 48px auto 64px auto;
  }
`

export const ArticleTitle = styled(Heading)`
  font-size: ${theme.token.var('fontSizes.md')};
  margin-bottom: 2px;
  line-height: 24px;
  font-weight: normal;

  @media (min-width: ${theme.token('breakpoints.lg')}) {
    font-size: ${theme.token.var('fontSizes.2xl')};
    margin-bottom: 16px;
    line-height: 48px;
  }
`

export const ArticleAuthor = styled(Text)`
  font-size: ${theme.token.var('fontSizes.xs')};
  font-weight: 600;

  @media (min-width: ${theme.token('breakpoints.lg')}) {
    font-size: ${theme.token.var('fontSizes.xs')};
  }
`

export const ArticleDate = styled(Text)`
  font-size: ${theme.token.var('fontSizes.xs')};
  color: ${theme.token.var('colors.green.a200')};

  @media (min-width: ${theme.token('breakpoints.lg')}) {
    font-size: ${theme.token.var('fontSizes.xs')};
  }
`
